/* eslint-disable */
export const NOTIFICATION_BASE_URL =
  process.env.REACT_APP_NOTIFICATION_BASE_URL;
export const AUTH_BASE_URL = process.env.REACT_APP_AUTH_BASE_URL;
export const CONTRACT_BASE_URL = process.env.REACT_APP_CONTRACT_BASE_URL;
export const PAYMENT_BASE_URL = process.env.REACT_APP_PAYMENT_BASE_URL;
export const PAYMENT_BASE_URL_V2 = process.env.REACT_APP_PAYMENT_BASE_URL_V2;
export const CONTRACT_VOUCHER_URL = process.env.REACT_APP_CONTRACT_VOUCHER_URL;
export const MOYASAR_PAYMENT_URL = process.env.REACT_APP_MOYASAR_PAYMENT_URL;
export const PAYMENT_URL_V2 = process.env.REACT_APP_PAYMENT_URL_V2;
export const CONTRACT_ACTION_BASES_URL =
  process.env.REACT_APP_CONTRACT_ACTION_BASES_URL;
export const REACT_APP_CONTRACT_BASE_URL =
  process.env.REACT_APP_CONTRACT_BASE_URL;

export const GET_BANKS_INFO = (id) => `/api/users/${id}/banks`;

export const POST_CERTIFICATE_LINK = (userId: string) =>
  `/api/users/certificate/broker/${userId}`;
export const GET_CERTIFICATE_LINK = () => `/api/users/certificate/broker`;
export const GET_TRANSACTION = "transactions";
export const GET_BALANCE = (id) => `/balances/${id}`;
export const GET_CHECK_FEEDBACK = (userId, contractId) =>
  `${FEEDBACK_URL}/eligible/${userId}/${contractId}`;
export const FEEDBACK_URL = "/api/feedbacks";
export const PROFILE_URL = "api/profiles";
export const REGISTRATION_URL = "/register";
export const PROFILES = "/profiles";
export const CONTRACT_URL = "/contracts";

export const PAYMENT_CALLBACK_URL = process.env.REACT_APP_PAYMENT_CALLBACK_URL;

export const ROUTES = {
  HOME: "/",
  AUTH: "/auth",
  RESET: "/reset-pincode",
  SIGNUP: "/signup",
  CONTRACT: "/contract/",
  CONTRACT_DETAILS: "/contract/:id",
  STOCK_CONTRACT: "/stock/contract/",
  CONTRACT_STOCK: "/stock/contract/:id",
  ONBOARDING: "/onboarding",
  MANAGE_SPECIAL_CONTRACT: "/contract/:type/:action/:id?",
  MANAGE_CUSTOMER_CONTRACT: "/contract/customer/:action/:id?",
  PRIVATE_CONTRACT_DETAILS: "/private-contract-details",
  CONTRACT_NOT_FOUND: "/not-found",
  CONTRACT_PAID: "/contract-paid",
  PROFILE: "/profile",
  CONTRACTS_LIST: "/contracts",
  USERS: "/users",
  PAYMENT: "/payment",
  DASHBOARD: "/dashboard",
  PAYMENTS: "/payments",
  USER: "/user/:id",
  WELLKNOWN: "/.wellknown/apple-developer-merchatid-domain-association.txt",
};
export const PROFILE_PATH_PARAMS = {
  ME: "info",
  ADDRESS: "address",
  ABSHER: "absher",
  BANK: "bank",
  PAYMENT_METHOD: "payment-methods",
  PIN_CODE: "pin-code",
  MOBILE_NUMBER: "phone-number",
  FEEDBACK: "feedbacks",
};
export const LOCALIZE_DATE = "ar-EG";

export const development = "development";
export const production = "production";
